import { useSelector } from 'react-redux';
import { getSelectedProcess } from '../../store/slices/domainOrchestratorPricingCommittee.slice';
import { useOrchestratorList } from '../../hooks/useOrchestratorList';
import { Clipboard } from '../shared/Clipboard';

export const OrchestratorNidsClipBoard = () => {
  const selectedProcess = useSelector(getSelectedProcess);
  const { orchestrators } = useOrchestratorList();
  const { data } = orchestrators;

  if (!selectedProcess) return null;

  const nids = data?.map(o => o.nid).join(',') ?? '';

  if (!nids) return null;

  return (
    <Clipboard text={nids} toastMessage="Nids copiados" dataTestId="copy-nids-button">
      Copiar nids filtrados
    </Clipboard>
  );
};
